module.exports = __webpack_public_path__ + "static/media/Group1.af1be30a.png";